import store from '@/store'

const beforeRoute = function(to, from, next) {
  const isNotRequiredAuth = to.matched.some(record => record.meta.noAuth)
  if (!store.getters.IS_LOGIN) {
    if (isNotRequiredAuth) {
      next()
    } else {
      goToLogin(to.fullPath, next)
    }
    return
  }

  if (store.getters.HAVE_AUTH_USER) {
    nextByRights(to, next)
  } else {
    store
      .dispatch('LOAD_AUTH_USER')
      .then(() => {
        nextByRights(to, next)
      })
      .catch(error => {
        if (error.response.status === 401 && isNotRequiredAuth) {
          next()
        } else if (error.response.status === 401) {
          goToLogin(null, next)
        } else {
          console.error(this.$t('errorMessage.cannotGetData'))
          console.error(error)
        }
      })
  }
}

const goToLogin = function(fullPath, next) {
  let params = {
    path: '/login'
  }
  if (fullPath && fullPath !== '/') {
    params.query = { redirect: fullPath }
  }
  next(params)
}

const nextByRights = function(to, next) {
  if (to.name === 'login' && to.query.redirect) {
    next({
      path: to.query.redirect
    })
    return
  }

  const allowHimself = to.matched.some(record => record.meta.allowHimself)
  if (allowHimself && store.getters.IS_HIMSELF(to.params.id)) {
    goNext(to, next)
  } else if (to.matched.some(record => record.meta.roles)) {
    const roles = getRoles(to.matched)
    store
      .dispatch('HAS_RIGHTS', roles)
      .then(() => {
        goNext(to, next)
      })
      .catch(() => {
        next({
          path: '/404'
        })
      })
  } else {
    goNext(to, next)
  }
}

const goNext = function(to, next) {
  if (!store.getters.HAS_NEURO_ADMIN) {
    next()
    return
  }

  if (to.query.hospital && !store.getters.IS_SELECTED_HOSPITAL) {
    store.dispatch('SET_HOSPITAL', to.query.hospital)
    next()
  } else if (!to.query.hospital && to.meta.ui !== 'neuro' && store.getters.SELECTED_HOSPITAL) {
    next({
      name: to.name,
      params: to.params,
      query: { hospital: store.getters.SELECTED_HOSPITAL }
    })
  } else {
    next()
  }
}

const getRoles = matched => {
  return matched.reduce((concat, record) => [].concat(concat, record.meta.roles), [])
}

export default beforeRoute
